import ClaimCreationErrorEvent from '@/domains/claims/events/ClaimCreationErrorEvent';

const ClaimEvents = {
  CreationError: ClaimCreationErrorEvent,
};

export default ClaimEvents;
